unit UTimeDataHelper;

interface

uses
  UZrValueList, UEssentialHelper, System.Contnrs;

type
  TZrItem = class
  private
    Received0: Boolean;
    Received1: Boolean;
    FFeiertag: Boolean;
    FZrValueList: TZrValueList;
    FDatum: TDateTime;
    FOnPropertyChanged: TCallback;
    function AllDataReceived: Boolean;
    procedure ClearValues;
    procedure IsFeiertag(Url: string; PersonalNr: string; Datum: TDateTime);
    procedure DataReceivedInIt;
    procedure PropertyChanged;
    procedure ZrValueListCallback(Sender: TObject);
    procedure SetDatum(const Value: TDateTime);
    procedure SetFeiertag(const Value: Boolean);
    procedure SetZrValueList(const Value: TZrValueList);
    procedure SetOnPropertyChanged(const Value: TCallback);
  public
    constructor Create;
    function ToString: string; override;
    procedure GetData(Url: string; PersonalNr: string);
    property Datum: TDateTime read FDatum write SetDatum;
    property Feiertag: Boolean read FFeiertag write SetFeiertag;
    property ZrValueList: TZrValueList read FZrValueList write SetZrValueList;
    property OnPropertyChanged: TCallback read FOnPropertyChanged
      write SetOnPropertyChanged;
  end;

  TZrList = class(TObjectList)
  private
    Url: string;
    FVon: TDateTime;
    FBis: TDateTime;
    FPersonalNr: string;
    FOnPropertyChanged: TCallback;
    function GetItem(i: Integer): TZrItem;
    procedure CreateItem(Datum: TDateTime);
    procedure PropertyChanged;
    procedure SetOnPropertyChanged(const Value: TCallback);
  public
    constructor Create(PersonalNr: string; Von, Bis: TDateTime);
    function GetCount: Integer;
    function GetIndexByDate(Datum: TDateTime): Integer;
    function ToString: string; override;
    procedure CreateItems(Url: string);
    procedure Add(item: TZrItem);
    procedure Insert(i: Integer; item: TZrItem);
    property Items[i: Integer]: TZrItem read GetItem;
    property Von: TDateTime read FVon;
    property Bis: TDateTime read FBis;
    property PersonalNr: string read FPersonalNr;
    property OnPropertyChanged: TCallback read FOnPropertyChanged
      write SetOnPropertyChanged;
  end;

implementation

uses
  WebLib.JSON, System.SysUtils, WebLib.REST, Js, Math, System.Classes;

{ TZrItem }

function TZrItem.AllDataReceived: Boolean;
begin
  Result := Self.Received0 and Self.Received1;
end;

procedure TZrItem.ClearValues;
begin
  Self.FDatum := 0;
  Self.FFeiertag := false;
  if Self.ZrValueList = nil then
  begin
    Self.ZrValueList := TZrValueList.Create;
    Self.ZrValueList.OnPropertyChanged := Self.ZrValueListCallback;
  end
  else
    Self.ZrValueList.Clear;
end;

constructor TZrItem.Create;
begin
  Self.ClearValues;
end;

procedure TZrItem.DataReceivedInIt;
begin
  Self.Received0 := false;
  Self.Received1 := false;
end;

procedure TZrItem.GetData(Url: string; PersonalNr: string);
begin
  Self.DataReceivedInIt;
  Self.ZrValueList.GetAll(Url, PersonalNr, Self.Datum);
  Self.IsFeiertag(Url, PersonalNr, Self.Datum);
end;

procedure TZrItem.IsFeiertag(Url, PersonalNr: string; Datum: TDateTime);
var
  obj: TJsonObject;
  helper: string;
  client: TRestClient;
  procedure Response(Sender: TObject; aResponse: string);
  var
    jso: TJsObject;
  begin
    jso := TJsJson.parseObject(aResponse);
    if jso['value'] <> nil then
      Self.Feiertag := StrToBoolean(string(jso['value']));
    Self.Received1 := true;
    if Self.AllDataReceived then
      Self.PropertyChanged;
  end;

begin
  obj := TJsonObject.Create;
  obj.AddPair('PersonalNr', PersonalNr);
  obj.AddPair('Datum', DateTimeToStr(Datum));
  helper := obj.ToString;
  obj := TJsonObject.Create;
  obj.AddPair('value', helper);
  client := TRestClient.Create(nil);
  client.OnResponse := Response;
  client.HttpsPost(Url + '/FeiertagService/IsFeiertag', 'application/json',
    obj.ToString);
  client.Free;
  obj.Free;
end;

procedure TZrItem.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TZrItem.SetDatum(const Value: TDateTime);
begin
  FDatum := Value;
end;

procedure TZrItem.SetFeiertag(const Value: Boolean);
begin
  FFeiertag := Value;
end;

procedure TZrItem.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TZrItem.SetZrValueList(const Value: TZrValueList);
begin
  FZrValueList := Value;
end;

function TZrItem.ToString: string;
begin
  Result := 'Datum: ' + DateTimeToStr(Self.Datum) + #13#10;
  Result := Result + 'Feiertag: ' + BooleanToStr(Self.Feiertag) + #13#10;
  Result := Result + Self.ZrValueList.ToString;
end;

procedure TZrItem.ZrValueListCallback(Sender: TObject);
begin
  Self.Received0 := true;
  if Self.AllDataReceived then
    Self.PropertyChanged;
end;

{ TZrList }

procedure TZrList.Add(item: TZrItem);
begin
  inherited Add(item);
end;

constructor TZrList.Create(PersonalNr: string; Von, Bis: TDateTime);
begin
  inherited Create;
  Self.FPersonalNr := PersonalNr;
  Self.FVon := Trunc(Von);
  Self.FBis := Trunc(Bis);
end;

procedure TZrList.CreateItem(Datum: TDateTime);
var
  item: TZrItem;
  procedure CallBack(Sender: TObject);
  begin
    if Sender is TZrItem then
      Self.Add(Sender as TZrItem);
    Self.CreateItem((Sender as TZrItem).Datum + 1);
  end;

begin
  if Datum <= Self.Bis then
  begin
    item := TZrItem.Create;
    item.Datum := Datum;
    item.OnPropertyChanged := CallBack;
    item.GetData(Self.Url, Self.PersonalNr);
  end
  else
    Self.PropertyChanged;
end;

procedure TZrList.CreateItems(Url: string);
begin
  Self.Url := Url;
  Self.CreateItem(Self.Von);
end;

function TZrList.GetCount: Integer;
var
  i: Integer;
begin
  Result := 0;
  for i := 0 to Self.Count - 1 do
    Result := Result + Max(1, Self.Items[i].ZrValueList.Count);
end;

function TZrList.GetIndexByDate(Datum: TDateTime): Integer;
var
  found: Boolean;
  i, erg: Integer;
begin
  erg := 0;
  i := 0;
  found := false;
  while not found and (i < Self.Count) do
    if Trunc(Self.Items[i].Datum) = Trunc(Datum) then
      found := true
    else
    begin
      erg := erg + Max(1, Self.Items[i].ZrValueList.Count);
      inc(i);
    end;
  if found then
    Result := erg
  else
    Result := -1;
end;

function TZrList.GetItem(i: Integer): TZrItem;
begin
  Result := inherited GetItem(i) as TZrItem;
end;

procedure TZrList.Insert(i: Integer; item: TZrItem);
begin
  inherited Insert(i, item);
end;

procedure TZrList.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TZrList.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

function TZrList.ToString: string;
var
  lst: TStringList;
  i: Integer;
begin
  lst := TStringList.Create;
  lst.Add('Count: ' + IntToStr(Self.Count));
  for i := 0 to Self.Count - 1 do
    lst.Add(Self.Items[i].ToString);
  Result := lst.Text;
  lst.Free;
end;

end.
